import { useTranslation } from "react-i18next";

import Nav from "../components/Header";
import Social from "../components/Social";
import Service from "../components/Service";
import Slider from "../components/Slider";
import Rate from "../components/Rate";
import Skills from "../components/Skills";
import Portfolio from "../components/Portfolio";
import Contact from "../components/Contact";
import Space from "../components/Space";

import Footer from "../components/Footer";

const Master = () => {
    const { t } = useTranslation();

    const toggleSidebar = () => {
        const header = document.querySelector(".header");
        if (header && header.classList.contains("active")) {
            header.classList.toggle("active");
        }
    };

    return (
        <>
            <Social />
            <Nav />
            <div className="master" onClick={toggleSidebar}>
                <Slider />
                <Service />
                <Space content={t("home.space.stack")} />
                <Skills />
                <Portfolio />
                <Space content={t("home.space.infra")} />
                <Rate />
                <Space content={t("home.space.freelance")} />
                <Contact />

                {/* <About/> */}
                <Footer />
            </div>
        </>
    );
};

export default Master;
